export default __webpack_public_path__ + "static/BasierCircle-Regular-8ce91e3cb869c7474b747d5e1bb592dd.woff";